import { useMemo, useState } from "react";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { ratingSummary, reviews } from "@/mocks/home";
import ReviewCard from "./ReviewCard";

const sortTabs = [
  { key: "hot", label: "最热书评" },
  { key: "new", label: "最新书评" },
];

export default function ReaderReviews() {
  const [sort, setSort] = useState("hot");

  const sortedReviews = useMemo(() => {
    if (sort === "hot") {
      return [...reviews].sort((a, b) => b.likes - a.likes);
    }
    return reviews;
  }, [sort]);

  return (
    <section id="reviews" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-6xl px-4 md:px-10 py-16 md:py-24">
        <Reveal>
          <SectionHeading
            eyebrow="读者书评"
            title="看完之后，他们这样说"
            desc="评分与评论来自读者社区的真实氛围，点赞和讨论一直在继续。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          <div className="lg:col-span-4">
            <Reveal>
              <div className="rounded-lg border border-background-200/80 bg-background-100 p-6">
                <div className="flex items-end gap-2">
                  <span className="font-heading text-5xl text-foreground-950">
                    {ratingSummary.score}
                  </span>
                  <span className="pb-2 text-sm font-label text-foreground-500">
                    / {ratingSummary.outOf}
                  </span>
                </div>
                <div className="mt-2 flex items-center gap-0.5 text-accent-500">
                  {Array.from({ length: 5 }).map((_, index) => (
                    <i key={index} className="ri-star-fill text-base" />
                  ))}
                </div>
                <p className="mt-3 text-sm text-foreground-600">
                  共 {ratingSummary.total}，好评率 93%
                </p>

                <div className="mt-6 space-y-3">
                  {ratingSummary.distribution.map((row) => (
                    <div key={row.star} className="flex items-center gap-3">
                      <span className="w-8 shrink-0 text-xs font-label text-foreground-500">
                        {row.star} 星
                      </span>
                      <span className="h-1.5 flex-1 rounded-full bg-background-300">
                        <span
                          className="block h-full rounded-full bg-accent-500"
                          style={{ width: `${row.percent}%` }}
                        />
                      </span>
                      <span className="w-9 shrink-0 text-right text-xs font-label text-foreground-500">
                        {row.percent}%
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <Reveal delay={80}>
              <div className="flex items-center justify-between gap-4">
                <div className="inline-flex items-center gap-1 rounded-full border border-background-300 bg-background-50 p-1">
                  {sortTabs.map((item) => (
                    <button
                      key={item.key}
                      type="button"
                      onClick={() => setSort(item.key)}
                      className={`px-4 py-1.5 rounded-full text-sm font-label transition-colors cursor-pointer whitespace-nowrap ${
                        sort === item.key
                          ? "bg-secondary-500 text-background-50"
                          : "text-foreground-600 hover:text-secondary-700"
                      }`}
                    >
                      {item.label}
                    </button>
                  ))}
                </div>
                <span className="hidden sm:block text-xs font-label text-foreground-400">
                  共 {reviews.length} 条精选书评
                </span>
              </div>
            </Reveal>

            <div className="mt-6 space-y-4">
              {sortedReviews.map((review, index) => (
                <Reveal key={`${review.name}-${review.time}`} delay={index * 60}>
                  <ReviewCard
                    name={review.name}
                    initial={review.initial}
                    rating={review.rating}
                    time={review.time}
                    text={review.text}
                    likes={review.likes}
                    replies={review.replies}
                  />
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}